<template lang="pug">
  WtTile#preventative-challenge-mobile(ancestor vertical)
    BModal#the-mobile-apps-notice(
      :active.sync="pointsAwardedModalOpen"
      has-modal-card
    )
      .modal-card
        header.modal-card-head.is-flex.is-justify-content-center
          WtTitle(h2) Well done!
        section.modal-card-body.is-flex.is-align-items-center.is-flex-direction-column
          WtTitle(h4) Your "{{challenge.name}}" challenge has been completed
          div.is-size-1.has-background-grey-lighter.px-5.points-earned {{pointsEarned}}
          p.is-size-4.mt-4 Points earned

        footer.modal-card-foot.custom-modal-card-foot.has-border-none
          WtButton.is-fullwidth(
            @click.native="pointsAwardedModalOpen = false"
          ) Done
    WtTile(parent)
      WtTile.is-flex.is-flex-direction-column.is-align-items-center.is-justify-content-center
        figure.mr-4
          p.image.is-96x96
            img.is-rounded.challenge-image(:src="_.get(challenge, 'map.image', null)" alt="")
        WtTitle.has-text-centered.pr-2.mb-0(h1 v-if="!_.isEmpty(challenge)") {{ _.get(challenge, 'name', '') }}
        BTag.is-rounded.preventative-challenge-tag.mb-5 Preventative care challenge
        .subtitle.level-item.is-size-6(v-if="!isCompleted") {{ challengeDates() }}&nbsp;&nbsp;
        .subtitle.level-item {{ daysRemainingInChallenge(challenge) }} {{ daysRemainingInChallengeText(challenge) }}
        MobileJoinButton(
          :challenge="challenge"
          :member="member"
        )
    WtTile.mt-6
      WtTile(vertical :col="4")
        WtTile.is-flex-grow-1(parent vertical)
          WtTitle.has-text-centered Challenge overview
          WtTile.is-flex-grow-1(child :col="12" :is-loading="!mobileChallengeLoaded")
            ChallengeOverview(
              :challenge="challenge"
            )
      WtTile(vertical).mt-5
        WtTile(parent vertical)
          WtTitle.has-text-centered  {{dateActionText}}
          WtTile(child :col="12")
            ChallengeCompletionDate(
              :is-completed="isCompleted"
              :challenge="challenge"
              :openPointsAwardedModal="openPointsAwardedModal"
            )
      WtTile(vertical).mt-5
        WtTile(parent vertical)
          WtTitle(v-if="displayFreeTextInput").has-text-centered  {{freeTextActionText}}
          WtTile(v-if="displayFreeTextInput" child :col="12" :is-loading="!mobileChallengeLoaded")
            .is-flex
              figure.mr-4
                p.image.is-48x48
                  img.is-rounded.challenge-image(:src="_.get(member, 'avatar', null)" alt="")
              ChallengeFreeText.is-flex-grow-1(
                :is-completed="isCompleted"
                :challenge="challenge"
              )
</template>

<script>
import { mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { challengeMixin } from "@/mixins/challengeMixin";
import WtButton from "@@/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import ChallengeOverview from "@@/Challenge/ChallengeOverview";
import MobileJoinButton from "@@/PreventativeChallengeMobile/MobileJoinButton";
import ChallengeCompletionDate from "@@/PreventativeChallengeMobile/ChallengeCompletionDate";
import ChallengeFreeText from "@@/PreventativeChallengeMobile/ChallengeFreeText";
export default {
  name: "MobilePreventativeChallenge",
  components: {
    WtButton,
    WtTile,
    WtTitle,
    ChallengeOverview,
    MobileJoinButton,
    ChallengeCompletionDate,
    ChallengeFreeText
  },
  mixins: [dateUtilityMixin, challengeMixin],
  props: {},
  data() {
    return {
      challengeLoaded: false,
      pointsAwardedModalOpen: false,
      pointsEarned: null
    };
  },
  computed: {
    ...mapGetters("pages", ["isPageLoaded", "isPageLoading"]),
    ...mapGetters("authMember", ["isAdmin"]),
    ...mapGetters("challenges", ["mobileChallenge", "mobileChallengeLoaded"]),
    ...mapGetters("members", ["member"]),
    showChallengeEditButton() {
      return false;
    },
    editChallengeRoute() {
      return false;
    },
    page() {
      return `Challenge${this.challengeId}`;
    },
    fullPageLoader() {
      // since there is no intial state for 'isPageLoading(this.page)'
      if (this._.isUndefined(this.isPageLoading(this.page))) {
        return true;
      }
      return this.isPageLoading(this.page);
    },
    challengeId() {
      return this.$route.params.challengeId;
    },
    isCompleted() {
      const COMPLETED = 2;
      return this.challenge.status === COMPLETED;
    },
    challenge() {
      return this.mobileChallenge;
    },
    hasCompletionDate() {
      return !!this.challenge.completionDate;
    },
    hasFreeText() {
      return !!this.challenge.freeText;
    },
    dateActionText() {
      if (this.isCompleted) {
        return "Completion date";
      }
      return this.hasCompletionDate
        ? "Update completion date"
        : "Add completion date";
    },
    freeTextActionText() {
      if (this.isCompleted) {
        return "Free text";
      }
      return this.hasFreeText ? "Update free text" : "Add free text";
    },
    displayFreeTextInput() {
      return this.challenge.allowFreeTextInput;
    }
  },
  methods: {
    challengeDates() {
      return (
        this.date(this.challenge.startDate, "DATE_FORMAT_SLASH").formatted +
        " - " +
        this.date(this.challenge.endDate, "DATE_FORMAT_SLASH").formatted
      );
    },
    openPointsAwardedModal(points) {
      this.pointsEarned = points;
      this.pointsAwardedModalOpen = true;
    }
  }
};
</script>

<style lang="sass" scoped>
#preventative-challenge-mobile
  .challenge-header
    width: 100%
    .column
      padding-left: 0
    .challenge-header-title
      margin-bottom: .5rem
    .level-item
      justify-content: flex-start
  .challenge-image
    height: 100%
    width: 100%
    object-fit: cover
  .preventative-challenge-tag
    background-color: $green-lighter
    color: $green-dark
  .modal-card
    header, footer
      border: none
    .points-earned
      border-radius: $radius
      color: $black
  .back-button
    background-color: $white-ter
</style>
